import PropTypes from 'prop-types';

import './SimpleButton.css';

import { buildClass } from '../../libs/classes';

export const ButtonTypes = {
	DEFAULT: 'default',
	GREY: 'grey',
	RED: 'red',
};

export const SimpleButton = ({ autoFocus, tabIndex, title, type, className, value, onClick }) => {
	return (
		<div className={buildClass('simple-button', className, type)}>
			<input
				autoFocus={autoFocus}
				tabIndex={tabIndex}
				title={title}
				type="button"
				value={value}
				onClick={onClick}
			/>
		</div>
	);
};

export const ButtonsWrapper = ({ children, className }) => {
	return <div className={buildClass('buttons-wrapper', className)}>{children}</div>;
};

SimpleButton.propTypes = {
	// Autofocus flag
	autoFocus: PropTypes.bool,
	// Custom tab order of an element
	tabIndex: PropTypes.number,
	// Title html attribute for component
	title: PropTypes.string,
	// Button type
	type: PropTypes.oneOf(Object.values(ButtonTypes)),
	// Custom class
	className: PropTypes.string,
	// Value of button
	value: PropTypes.string.isRequired,
	// Callback function on click
	onClick: PropTypes.func.isRequired,
};

ButtonsWrapper.propTypes = {
	// Additional class name
	className: PropTypes.string,
	// Button components
	children: PropTypes.node.isRequired,
};

export default SimpleButton;
